<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Arrow_02">
            <path id="Vector 27 (Stroke)" fill-rule="evenodd" clip-rule="evenodd"
                d="M12.0303 10.2803C11.7374 10.5732 11.2626 10.5732 10.9697 10.2803L8 7.31066L5.03033 10.2803C4.73744 10.5732 4.26256 10.5732 3.96967 10.2803C3.67678 9.98744 3.67678 9.51256 3.96967 9.21967L7.46967 5.71967C7.76256 5.42678 8.23744 5.42678 8.53033 5.71967L12.0303 9.21967C12.3232 9.51256 12.3232 9.98744 12.0303 10.2803Z"
                :fill=fill />
        </g>
    </svg>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: {
        fill: {
            default: '#667488'
        }
    }
}
</script>
